import styled from 'styled-components';
import banner from '../../assets/images/case_banner_bg.png';

const StyledContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: 120px;
	padding: 20px;
	border-radius: 10px;
	background-image: url(${banner});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border: 1px solid #c71e1e;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: #ffffff;
`;

const StyledButton = styled.div`
	width: 50px;
	height: 100%;
	background-color: #c71e1e;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

export { StyledButton, StyledContainer, StyledLeftContainer };
